import appLogo from './appIcon.svg';

export const imageKeyMappings = {
    appLogo
}